module.exports = __webpack_public_path__ + "static/media/githubwhite.89c2c067.png";